module.exports = __webpack_public_path__ + "img/menu-bar-off_01.6f2557f9.png";